import React, { useState } from 'react';
import { Search, Sparkles } from 'lucide-react';
import { Button } from './ui/button';

const SearchBar = ({ onSearch, loading = false }) => {
  const [query, setQuery] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (query.trim()) {
      onSearch(query);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="w-full max-w-3xl mx-auto px-2 sm:px-0">
      <div className="relative group" data-testid="search-form">
        <div className="absolute inset-0 bg-gradient-to-r from-primary/20 to-secondary/20 rounded-xl sm:rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-300 opacity-0 group-hover:opacity-100" />
        <div className="relative flex items-center bg-card/50 backdrop-blur-md border border-border hover:border-primary/50 rounded-xl sm:rounded-2xl shadow-lg transition-all duration-300">
          <Search className="absolute left-3 sm:left-6 text-muted-foreground" size={20} />
          <input
            data-testid="search-input"
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Ask anything..."
            className="w-full min-w-0 pl-10 sm:pl-16 pr-[5.5rem] sm:pr-32 py-3.5 sm:py-6 bg-transparent text-base sm:text-lg font-body placeholder:text-muted-foreground focus:outline-none"
            disabled={loading}
          />
          <Button
            data-testid="search-button"
            type="submit"
            disabled={!query.trim() || loading}
            className="absolute right-1.5 sm:right-2 rounded-full px-3 sm:px-6 py-2 sm:py-3 bg-primary hover:bg-primary/90 text-primary-foreground font-medium shadow-[0_0_15px_-3px_rgba(45,212,191,0.4)] transition-all hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed text-sm sm:text-base shrink-0"
          >
            {loading ? (
              <span className="flex items-center gap-1 sm:gap-2">
                <Sparkles className="animate-spin" size={16} />
                <span className="hidden sm:inline">Searching...</span>
                <span className="sm:hidden">...</span>
              </span>
            ) : (
              'Search'
            )}
          </Button>
        </div>
      </div>
    </form>
  );
};

export default SearchBar;